import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-black shadow-lg sticky top-0 z-10" }
const _hoisted_2 = { class: "container w-full mx-auto px-3 md:px-0" }
const _hoisted_3 = { class: "w-full py-3 grid grid-cols-3 text-white font-semibold uppercase text-sm md:px-2" }
const _hoisted_4 = { class: "flex items-center justify-start font-semibold uppercase col-span-2 md:col-span-1" }
const _hoisted_5 = {
  key: 0,
  class: "truncate w-7/12"
}
const _hoisted_6 = { class: "hidden md:flex items-center justify-center md:text-center" }
const _hoisted_7 = { class: "relative flex items-center justify-end" }
const _hoisted_8 = {
  key: 0,
  class: "hidden md:inline-block uppercase md:mx-1"
}
const _hoisted_9 = { class: "w-60 bg-gray-600 rounded-md shadow-lg" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "md:hidden text-white font-semibold uppercase text-sm z-60"
}
const _hoisted_13 = { class: "flex flex-col px-2 py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fab', 'elementor'],
            class: "text-2xl mr-2 hidden md:inline-block"
          }),
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'bars'],
            class: "text-2xl mr-2 inline-block md:hidden cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
          }),
          (_ctx.evento)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.evento.descripcion), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/empresa",
            class: "rounded-md px-3 py-2 text-white hover:bg-gray-700 hover:text-white"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['far', 'building'],
                class: "mr-1"
              }),
              _cache[4] || (_cache[4] = _createTextVNode(" Empresa "))
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/invitaciones",
            class: "rounded-md px-3 py-2 text-white hover:bg-gray-700 hover:text-white"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'ticket'],
                class: "mr-1"
              }),
              _cache[5] || (_cache[5] = _createTextVNode(" Acreditados "))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isUserOpen = !_ctx.isUserOpen)),
            class: "rounded-md px-3 py-2 text-white hover:bg-gray-700 z-50"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: ['far', 'user'] }),
            (_ctx.usuarioEmpresa)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.usuarioEmpresa.nombreCompleto), 1))
              : _createCommentVNode("", true),
            (!_ctx.isUserOpen)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: ['fas', 'chevron-down']
                }))
              : _createCommentVNode("", true),
            (_ctx.isUserOpen)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 2,
                  icon: ['fas', 'chevron-up']
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isUserOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 bg-transparent z-40",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isUserOpen = false))
              }))
            : _createCommentVNode("", true),
          (_ctx.isUserOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["absolute right-0 z-50 font-normal", { 'mt-44': _ctx.empresa.expositor, 'mt-32': !_ctx.empresa.expositor }])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: "/perfil",
                    class: "block rounded-t-md px-4 py-2 text-white hover:bg-gray-700"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: ['far', 'user'] }),
                      _cache[6] || (_cache[6] = _createTextVNode(" Mi Perfil "))
                    ]),
                    _: 1
                  }),
                  (_ctx.empresa.expositor)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: 'https://cloud.qreventos.com/empresas/catalogoMarco/' + _ctx.evento.id,
                        target: "catalogo",
                        class: "block rounded-b-md px-4 py-2 text-white hover:bg-gray-700 cursor-pointer"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['far', 'circle-right'] }),
                        _cache[7] || (_cache[7] = _createTextVNode(" Ver catálogo "))
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (_ctx.empresa.expositor)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: 'https://cloud.qreventos.com/empresas/catalogo/' + _ctx.evento.id,
                        target: "catalogo",
                        class: "block rounded-b-md px-4 py-2 text-white hover:bg-gray-700 cursor-pointer"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['far', 'circle'] }),
                        _cache[8] || (_cache[8] = _createTextVNode(" Catálogo sin marco "))
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                    class: "block rounded-b-md px-4 py-2 text-white hover:bg-gray-700 cursor-pointer"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'right-from-bracket'] }),
                    _cache[9] || (_cache[9] = _createTextVNode(" Cerrar sesión "))
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "h-[1px] bg-gray-500 w-full" }, null, -1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: "/empresa",
              class: "rounded-md px-3 py-2 text-white hover:bg-gray-700"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['far', 'building'],
                  class: "mr-1"
                }),
                _cache[10] || (_cache[10] = _createTextVNode(" Empresa "))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/productos",
              class: "rounded-md px-3 py-2 text-white hover:bg-gray-700"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'box'],
                  class: "mr-1"
                }),
                _cache[11] || (_cache[11] = _createTextVNode(" Productos "))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/invitaciones",
              class: "rounded-md px-3 py-2 text-white hover:bg-gray-700"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'ticket'],
                  class: "mr-1"
                }),
                _cache[12] || (_cache[12] = _createTextVNode(" Invitaciones "))
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "h-[1px] bg-gray-500 w-full" }, null, -1))
  ]))
}